var youbora = require('youboralib')
var manifest = require('../../manifest.json')

var AdsAdapter = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    return this.playhead || 0
  },

  /** Override to return video duration */
  getDuration: function () {
    return this.duration
  },

  /** Override to return current bitrate */
  getBitrate: function () {
    return this.bitrate
  },

  /** Override to return title */
  getTitle: function () {
    return this.title
  },

  /** Override to return resource URL. */
  getResource: function () {
    return this.resource
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    var version = $pdk ? $pdk.version.toString() : ''
    if (version === "[object Object]") {
      if ($pdk.version.major && $pdk.version.minor && $pdk.version.revision && $pdk.version.build) {
        version = $pdk.version.major + '.' + $pdk.version.minor + '.' + $pdk.version.revision + '.' + $pdk.version.build
      }
    }
    return version
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return 'ThePlatform'
  },

  /** Override to return current ad position (only ads) */
  getPosition: function () {
    return this.adPosition
  },

  /** Register listeners to this.player. */
  registerListeners: function () {

    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, false)

    // Register listeners
    this.references = []
    this.references['OnMediaLoadStart'] = this.loadListener.bind(this)
    this.references['OnMediaError'] = this.errorListener.bind(this)
    this.references['OnMediaEnd'] = this.endListener.bind(this)
    this.references['OnMediaPlaying'] = this.playingListener.bind(this)
    this.references['OnMediaPause'] = this.pauseListener.bind(this)
    this.references['OnMediaUnpause'] = this.unpauseListener.bind(this)
    this.references['OnMediaClick'] = this.clickListener.bind(this)

    for (var key in this.references) {
      this.player.addEventListener(key, this.references[key])
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    this.monitor.stop()

    // unregister listeners
    if (this.player && this.references) {
      for (var key in this.references) {
        this.player.removeEventListener(key, this.references[key])
      }
      this.references = []
    }
  },

  /** Listener for 'OnMediaLoadStart' event. */
  loadListener: function (e) {
    var bc = e.data.baseClip || e.data.clip
    if (bc.isAd) {
      this.duration = (bc.releaseLength || bc.length) / 1000
      this.bitrate = bc.bitrate || 0
      this.resource = bc.URL
      this.title = e.data.title
      if (bc.moreInfo) this.clickURL = bc.moreInfo.href
      this.adPosition = 'pre'
      if (this.plugin.getAdapter().getDuration() <= this.plugin.getAdapter().getPlayhead() + 2) {
        this.adPosition = 'post'
      } else if (this.plugin.getAdapter().flags.isJoined) {
        this.adPosition = 'mid'
      }
    }
  },

  /** Listener for 'OnMediaError' event. */
  errorListener: function (e) {
    if (this.flags.isStarted || this.flags.isInited) {
      this.fireError(e.data.friendlyMessage || e.data.message)
      this.fireStop()
      this.plugin.getAdapter().fireResume()
    }
  },

  /** Listener for 'OnMediaEnd' event. */
  endListener: function (e) {
    this.fireStop()
    this.plugin.getAdapter().fireResume()
    this.resetValues()
  },

  /** Listener for 'OnMediaPlaying' event. */
  playingListener: function (e) {
    if (this.flags.isStarted || this.flags.isInited) {
      this.playhead = (e.data.currentTimeAggregate ? e.data.currentTimeAggregate : e.data.currentTime) / 1000
      this.fireJoin()
      this.monitor.skipNextTick()
    }
  },

  /** Listener for 'OnMediaPause' event. */
  pauseListener: function (e) {
    this.firePause()
  },

  /** Listener for 'OnMediaUnpause' event. */
  unpauseListener: function (e) {
    this.fireResume()
  },

  clickListener: function (e) {
    this.fireClick({ 'url': this.clickURL })
  },

  resetValues: function () {
    this.resource = null
    this.title = null
    this.duration = null
    this.playhead = null
    this.duration = null
    this.bitrate = null
    this.adPosition = null
    this.clickURL = null
  }
})

module.exports = AdsAdapter
